<template>
  <div class="top-bar drag">
    <v-layout row justify-space-between align-center>
      <v-flex shrink>
        <slot><div style="width: 28px"/></slot>
      </v-flex>

      <v-flex class="top-bar-title">{{ title }}</v-flex>

      <v-flex shrink>
        <window-header-button action="newtab" v-if="isMultiSelect" @onClick="openTab"/>
        <window-header-button @onClick="$emit('close')" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import WindowHeaderButton from "@/components/_Atoms/WindowHeaderButton";

export default {
  name: "FormHeader",

  components: { WindowHeaderButton },

  props: {
    title: {
      type: String,
      required: true
    },

    isMultiSelect: {
      type: Boolean,
      default: false
    }
  },

  computed:{
    getWorkspaceUUID(){
      return sessionStorage.getItem("workspace_uuid");
    },
  },

  methods:{
    openTab(){
      window.localStorage.setItem('multiObjectSelection', JSON.stringify(this.$store.getters.getMultiObjectSelection));
      const routeData = this.$router.resolve({name: 'multiselect', params: {workspaceUUID: this.getWorkspaceUUID}});
      window.open(routeData.href, '_blank');
    }
  },
};
</script>

<style scoped>
.top-bar {
  height: 40px;
  line-height: 34px;
  text-transform: uppercase;
  background-color: #32383d;
  color: #fafbfc;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14);
  font-size: 12px;
}
.top-bar-title{
  text-align: center;
  max-width: 85%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Molecules/FormHeader.vue